export function clearParams<T extends object>(params: T) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => Boolean(value) || value === 0)
  );
}
